export const allowedTags = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "ul",
  "ol",
  "li",
  "blockquote",
  "p",
  "u",
  "em",
  "strong",
  "br",
  "a",
  "img",
  "form",
  "input",
  "noscript",
  "span",
  "br",
];
